// eslint-disable-next-line no-use-before-define
import React from 'react';
import { logoCoraBase64 } from '../../../../../assets/base64/cora-logo';
/** A logo leva para a home — a rota "/", que o router mapeia para o MFE home. */
export const Logo = ({ onClick }) => {
    return (React.createElement("div", { className: 'main-menu_logo' },
        React.createElement("button", { type: "button", onClick: onClick, title: "Logo Cora" },
            React.createElement("img", { alt: "Logo Cora", src: logoCoraBase64 }))));
};
//# sourceMappingURL=logo.js.map